import React from 'react';
import {LayoutDashboard, BookUpload, ExternalLink} from 'tabler-icons-react';
import {ThemeIcon, UnstyledButton, Group, Text} from '@mantine/core';
import {Link, PathMatch, useMatch, useResolvedPath} from "react-router-dom";
import useUserStore from "../../../data/User.store";
import { link } from 'fs';
import { resolve } from 'path';
import { color } from 'highcharts';

interface MainLinkProps {
    icon: React.ReactNode;
    color: string;
    label: string;
    link: string;
    isExternal?: boolean;
}

function MainLink({icon, color, label, link, isExternal}: MainLinkProps) {
    const {user} = useUserStore();
    let resolved: any | null
    let match: PathMatch<string> | null 
    function getStyles(theme:any) {
        let curTheme:any = {
            display: 'block',
            padding: theme.spacing.xs,
            borderRadius: theme.radius.sm,
            color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black,
            marginBottom:6,
            '&:last-of-type': {
                marginBottom: 0,
            },
            '&:hover': {
                backgroundColor:
                    theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
            },
        }
        if (match?.pathnameBase && resolved.pathname.startsWith(match.pathnameBase)){

            curTheme.backgroundColor = theme.colors.dark[6]
        }
        return curTheme;
    }
    return (
        <UnstyledButton
            component={Link}
            to={link}
            sx={getStyles}
            onClick={() => {if(isExternal) {window.open(`${link}?SessionID=${user?.sessionID}`, '_blank')}}}
        >
            <Group>
                <ThemeIcon color={color} variant="light">
                    {icon}
                </ThemeIcon>
                <Text size="sm">{label}</Text>
            </Group>
        </UnstyledButton>
        );
}

const oceanImportUrl = process.env.REACT_APP_AGL_REDIRECT_URL ? process.env.REACT_APP_AGL_REDIRECT_URL : ""

export function MainLinks() {
    let data = [
        {icon: <LayoutDashboard size={16}/>, color: 'blue', label: 'Dashboard', link: "/dashboard"},
        {icon: <BookUpload size={16}/>, color: 'blue', label: 'Create Booking', link: "/create-booking"},
        // {icon: <LayoutDashboard size={16}/>, color: 'blue', label: 'Booking for Approval', link: "/bookings/approvals"},
        {icon: <LayoutDashboard size={16}/>, color: 'blue', label: 'Rates for Approval', link: "/rates/approvals"},
        {icon: <ExternalLink size={16}/>, color: 'blue', label: 'Ocean Import', link: oceanImportUrl, isExternal: true},
        {icon: <LayoutDashboard size={16}/>, color: 'blue', label: 'Agent Review', link: "/agent/review"},
        {icon: <LayoutDashboard size={16}/>, color: 'blue', label: 'Shipment Tracking', link: "/shipment-tracking"},
    ];
    const { user } = useUserStore();
    let userPermissionsArr: any[] = []
    let pointer = 0;
    data.forEach(element => {
        let sidebarComponent = data.find(element => {
            if (user?.permissions){
                return element.label === user?.permissions[pointer];
            } else {
                return false;
            }
        })
        if(sidebarComponent)
        userPermissionsArr.push(sidebarComponent)
        pointer++
    });
    const links = userPermissionsArr.map((link) => <MainLink {...link} key={link.label}/>)
    return <div>{links}</div>;
}